import React, { useState } from 'react';
import {
    Search,
    Eye,
    FileText,
    UserCheck,
    FileSignature,
    X,
    CheckCircle,
    XCircle,
    Ban,
    Info,
} from 'lucide-react';
import './Actionspreembauche.css';

// Données statiques
const CANDIDATURES_DATA = [
    {
        id: 1,
        candidatTheque: {
            nom: 'Benali',
            prenom: 'Ahmed',
            email: 'ahmed.benali@email.com',
            phone: '+212 6 12 34 56 78',
        },
        demandeRecrutement: {
            demandeur: {
                nom: 'Alami',
                prenom: 'Fatima',
                poste: { nom: 'Développeur Full Stack' },
            },
        },
        statutDeCandidature: 'Traitement administratif',
        departement: 'IT',
        motifRejet: '',
        motifAnnulation: '',
    },
    {
        id: 2,
        candidatTheque: {
            nom: 'El Amrani',
            prenom: 'Youssef',
            email: 'youssef.amrani@email.com',
            phone: '+212 6 23 45 67 89',
        },
        demandeRecrutement: {
            demandeur: {
                nom: 'Benkirane',
                prenom: 'Karim',
                poste: { nom: 'Chef de projet' },
            },
        },
        statutDeCandidature: 'Confirmée',
        departement: 'Management',
        motifRejet: '',
        motifAnnulation: '',
    },
    {
        id: 3,
        candidatTheque: {
            nom: 'Chakir',
            prenom: 'Salma',
            email: 'salma.chakir@email.com',
            phone: '+212 6 34 56 78 90',
        },
        demandeRecrutement: {
            demandeur: {
                nom: 'Tazi',
                prenom: 'Omar',
                poste: { nom: 'Data Analyst' },
            },
        },
        statutDeCandidature: 'Traitement administratif',
        departement: 'Data',
        motifRejet: '',
        motifAnnulation: '',
    },
    {
        id: 4,
        candidatTheque: {
            nom: 'Idrissi',
            prenom: 'Mehdi',
            email: 'mehdi.idrissi@email.com',
            phone: '+212 6 45 67 89 01',
        },
        demandeRecrutement: {
            demandeur: {
                nom: 'Alami',
                prenom: 'Fatima',
                poste: { nom: 'Designer UX/UI' },
            },
        },
        statutDeCandidature: 'Rejetée',
        departement: 'Design',
        motifRejet: 'Compétences techniques insuffisantes',
        motifAnnulation: '',
    },
    {
        id: 5,
        candidatTheque: {
            nom: 'Lahlou',
            prenom: 'Nadia',
            email: 'nadia.lahlou@email.com',
            phone: '+212 6 56 78 90 12',
        },
        demandeRecrutement: {
            demandeur: {
                nom: 'Benkirane',
                prenom: 'Karim',
                poste: { nom: 'Responsable RH' },
            },
        },
        statutDeCandidature: 'Annulée',
        departement: 'RH',
        motifRejet: '',
        motifAnnulation: 'Le candidat a décliné l\'offre',
    },
];

const STATUS_OPTIONS = ['Confirmée', 'Traitement administratif', 'Rejetée', 'Annulée'];

const Modal = ({ open, title, children, footer, onClose, size = 'md' }) => {
    if (!open) return null;
    const sizeClass = size === 'lg' ? 'apeModal__panel--lg' : '';
    return (
        <div className="apeModal" role="dialog" aria-modal="true" onMouseDown={onClose}>
            <div className={`apeModal__panel ${sizeClass}`} onMouseDown={(e) => e.stopPropagation()}>
                <div className="apeModal__header">
                    <div className="apeModal__title">{title}</div>
                    <button className="apeIconBtn" onClick={onClose} aria-label="Fermer">
                        <X size={18} />
                    </button>
                </div>
                <div className="apeModal__body">{children}</div>
                {footer && <div className="apeModal__footer">{footer}</div>}
            </div>
        </div>
    );
};

export default function ActionsPreEmbauche() {
    const [candidatures] = useState(CANDIDATURES_DATA);
    const [filteredCandidatures, setFilteredCandidatures] = useState(CANDIDATURES_DATA);

    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showProcedureModal, setShowProcedureModal] = useState(false);
    const [showRejetModal, setShowRejetModal] = useState(false);
    const [showAnnulerModal, setShowAnnulerModal] = useState(false);
    const [showMotifModal, setShowMotifModal] = useState(false);

    const [selectedCandidature, setSelectedCandidature] = useState(null);
    const [motif, setMotif] = useState('');

    const [filters, setFilters] = useState({
        nomCandidat: '',
        email: '',
        phone: '',
        nomManager: '',
        statut: '',
    });

    const handleFilterChange = (field, value) => {
        const newFilters = { ...filters, [field]: value };
        setFilters(newFilters);

        let filtered = candidatures;

        if (newFilters.nomCandidat) {
            filtered = filtered.filter((c) => {
                const nomComplet = `${c.candidatTheque.nom} ${c.candidatTheque.prenom}`;
                return nomComplet.toLowerCase().includes(newFilters.nomCandidat.toLowerCase());
            });
        }

        if (newFilters.email) {
            filtered = filtered.filter((c) =>
                c.candidatTheque.email.toLowerCase().includes(newFilters.email.toLowerCase())
            );
        }

        if (newFilters.phone) {
            filtered = filtered.filter((c) =>
                c.candidatTheque.phone.toLowerCase().includes(newFilters.phone.toLowerCase())
            );
        }

        if (newFilters.nomManager) {
            filtered = filtered.filter((c) => {
                const nomComplet = `${c.demandeRecrutement.demandeur.nom} ${c.demandeRecrutement.demandeur.prenom}`;
                return nomComplet.toLowerCase().includes(newFilters.nomManager.toLowerCase());
            });
        }

        if (newFilters.statut) {
            filtered = filtered.filter((c) => c.statutDeCandidature === newFilters.statut);
        }

        setFilteredCandidatures(filtered);
    };

    const resetFilters = () => {
        setFilters({
            nomCandidat: '',
            email: '',
            phone: '',
            nomManager: '',
            statut: '',
        });
        setFilteredCandidatures(candidatures);
    };

    const isAnyFilterFilled = Object.values(filters).some((val) => val !== '');

    const getStatusClass = (status) => {
        switch (status) {
            case 'Traitement administratif':
                return 'apePill--processing';
            case 'Confirmée':
                return 'apePill--confirmed';
            case 'Rejetée':
                return 'apePill--rejected';
            case 'Annulée':
                return 'apePill--cancelled';
            default:
                return '';
        }
    };

    const openDetails = (candidature) => {
        setSelectedCandidature(candidature);
        setShowDetailsModal(true);
    };

    const openMotifDetails = (candidature) => {
        setSelectedCandidature(candidature);
        setShowMotifModal(true);
    };

    const openConfirmation = (candidature) => {
        setSelectedCandidature(candidature);
        setShowConfirmationModal(true);
    };

    const openProcedure = (candidature) => {
        setSelectedCandidature(candidature);
        setShowProcedureModal(true);
    };

    const openRejet = (candidature) => {
        setSelectedCandidature(candidature);
        setMotif('');
        setShowRejetModal(true);
    };

    const openAnnuler = (candidature) => {
        setSelectedCandidature(candidature);
        setMotif('');
        setShowAnnulerModal(true);
    };

    const confirmerCandidature = () => {
        console.log('Confirmer candidature:', selectedCandidature?.id);
        setShowConfirmationModal(false);
        setSelectedCandidature(null);
    };

    const rejeterCandidature = () => {
        if (!motif.trim()) {
            alert('Veuillez préciser le motif de rejet');
            return;
        }
        console.log('Rejeter candidature:', selectedCandidature?.id, 'Motif:', motif);
        setShowRejetModal(false);
        setSelectedCandidature(null);
        setMotif('');
    };

    const annulerCandidature = () => {
        if (!motif.trim()) {
            alert('Veuillez préciser le motif d\'annulation');
            return;
        }
        console.log('Annuler candidature:', selectedCandidature?.id, 'Motif:', motif);
        setShowAnnulerModal(false);
        setSelectedCandidature(null);
        setMotif('');
    };

    const isActionDisabled = (candidature) => {
        return ['Confirmée', 'Rejetée', 'Annulée'].includes(candidature.statutDeCandidature);
    };

    // Gérer le scroll du body quand un modal est ouvert
    React.useEffect(() => {
        const isAnyModalOpen =
            showDetailsModal ||
            showConfirmationModal ||
            showProcedureModal ||
            showRejetModal ||
            showAnnulerModal ||
            showMotifModal;
        if (isAnyModalOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [
        showDetailsModal,
        showConfirmationModal,
        showProcedureModal,
        showRejetModal,
        showAnnulerModal,
        showMotifModal,
    ]);

    return (
        <div className="apePage">
            <div className="apeHeader">
                <div>
                    <h1>Actions Pré-embauche</h1>
                    <p>Gérez les candidatures en phase de traitement administratif</p>
                </div>
            </div>

            {/* Section Filtres */}
            <div className="apeWrap">
                <div className="apeCard">
                    <div className="apeBody">
                        <div className="apeFilterSection">
                            <div className="apeFilterTitle">
                                <Search size={16} />
                                Filtre de recherche
                            </div>

                            <div className="apeFilterGrid">
                                <div className="apeField">
                                    <label>Candidat</label>
                                    <input
                                        type="text"
                                        value={filters.nomCandidat}
                                        onChange={(e) => handleFilterChange('nomCandidat', e.target.value)}
                                        placeholder="Rechercher par nom..."
                                    />
                                </div>

                                <div className="apeField">
                                    <label>Email</label>
                                    <input
                                        type="text"
                                        value={filters.email}
                                        onChange={(e) => handleFilterChange('email', e.target.value)}
                                        placeholder="Rechercher par email..."
                                    />
                                </div>

                                <div className="apeField">
                                    <label>Numéro de téléphone</label>
                                    <input
                                        type="text"
                                        value={filters.phone}
                                        onChange={(e) => handleFilterChange('phone', e.target.value)}
                                        placeholder="Rechercher par téléphone..."
                                    />
                                </div>

                                <div className="apeField">
                                    <label>Manager</label>
                                    <input
                                        type="text"
                                        value={filters.nomManager}
                                        onChange={(e) => handleFilterChange('nomManager', e.target.value)}
                                        placeholder="Rechercher par manager..."
                                    />
                                </div>

                                <div className="apeField">
                                    <label>Statut de candidature</label>
                                    <select
                                        value={filters.statut}
                                        onChange={(e) => handleFilterChange('statut', e.target.value)}
                                    >
                                        <option value="">Tous</option>
                                        {STATUS_OPTIONS.map((s) => (
                                            <option key={s} value={s}>
                                                {s}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="apeFilterActions">
                                <button
                                    className={`apeBtn ${isAnyFilterFilled ? 'apeBtn--warning' : 'apeBtn--ghost'}`}
                                    type="button"
                                    onClick={resetFilters}
                                    disabled={!isAnyFilterFilled}
                                >
                                    Réinitialiser les filtres
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section Liste */}
            <div className="apeWrap">
                <div className="apeCard">
                    <div className="apeBody">
                        <div className="apeTopRow">
                            <h2 className="apeTitle">Actions pré-embauche ({filteredCandidatures.length})</h2>
                        </div>

                        <div className="apeTableWrap">
                            <table className="apeTable">
                                <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Candidat</th>
                                    <th>Poste</th>
                                    <th>Manager</th>
                                    <th>Statut de candidature</th>
                                    <th className="is-right">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {filteredCandidatures.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="apeEmptyCell">
                                            Aucune candidature trouvée
                                        </td>
                                    </tr>
                                ) : (
                                    filteredCandidatures.map((candidature) => (
                                        <tr key={candidature.id}>
                                            <td>
                                                <span className="apeStrong">{candidature.id}</span>
                                            </td>
                                            <td>
                                                <div className="apeInline">
                            <span className="apeStrong">
                              {candidature.candidatTheque.nom} {candidature.candidatTheque.prenom}
                            </span>
                                                    <button
                                                        className="apeIconBtn apeIconBtn--info"
                                                        type="button"
                                                        title="Détails candidat"
                                                        onClick={() => openDetails(candidature)}
                                                    >
                                                        <Info size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                            <td className="apeMuted">
                                                {candidature.demandeRecrutement.demandeur.poste.nom}
                                            </td>
                                            <td className="apeMuted">
                                                {candidature.demandeRecrutement.demandeur.nom}{' '}
                                                {candidature.demandeRecrutement.demandeur.prenom}
                                            </td>
                                            <td>
                                                <div className="apeInline">
                                                    <button
                                                        className={`apePill ${getStatusClass(candidature.statutDeCandidature)}`}
                                                        type="button"
                                                        disabled
                                                    >
                                                        {candidature.statutDeCandidature}
                                                    </button>
                                                    {(candidature.statutDeCandidature === 'Rejetée' ||
                                                        candidature.statutDeCandidature === 'Annulée') && (
                                                        <button
                                                            className="apeIconBtn apeIconBtn--danger"
                                                            type="button"
                                                            title="Voir le motif"
                                                            onClick={() => openMotifDetails(candidature)}
                                                        >
                                                            <Info size={16} />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="is-right">
                                                <div className="apeRowActions">
                                                    <button
                                                        className="apeIconBtn"
                                                        type="button"
                                                        title="Lettre de confirmation de recrutement"
                                                        onClick={() => openConfirmation(candidature)}
                                                    >
                                                        <FileText size={16} />
                                                    </button>
                                                    <button
                                                        className="apeIconBtn"
                                                        type="button"
                                                        title="Procédure intégration"
                                                        onClick={() => openProcedure(candidature)}
                                                    >
                                                        <UserCheck size={16} />
                                                    </button>
                                                    <button
                                                        className="apeIconBtn"
                                                        type="button"
                                                        title="Contrat de travail"
                                                        onClick={() => console.log('Télécharger contrat:', candidature.id)}
                                                    >
                                                        <FileSignature size={16} />
                                                    </button>
                                                    <button
                                                        className={`apeIconBtn ${
                                                            isActionDisabled(candidature) ? 'apeIconBtn--disabled' : 'apeIconBtn--danger'
                                                        }`}
                                                        type="button"
                                                        title={
                                                            isActionDisabled(candidature)
                                                                ? 'Annuler pas disponible'
                                                                : 'Annuler'
                                                        }
                                                        onClick={() => openAnnuler(candidature)}
                                                        disabled={isActionDisabled(candidature)}
                                                    >
                                                        <XCircle size={16} />
                                                    </button>
                                                    <button
                                                        className={`apeIconBtn ${
                                                            isActionDisabled(candidature) ? 'apeIconBtn--disabled' : 'apeIconBtn--success'
                                                        }`}
                                                        type="button"
                                                        title={
                                                            isActionDisabled(candidature)
                                                                ? 'Confirmer pas disponible'
                                                                : 'Confirmer'
                                                        }
                                                        onClick={() => confirmerCandidature()}
                                                        disabled={isActionDisabled(candidature)}
                                                    >
                                                        <CheckCircle size={16} />
                                                    </button>
                                                    <button
                                                        className={`apeIconBtn ${
                                                            isActionDisabled(candidature) ? 'apeIconBtn--disabled' : 'apeIconBtn--danger'
                                                        }`}
                                                        type="button"
                                                        title={
                                                            isActionDisabled(candidature) ? 'Rejeter pas disponible' : 'Rejeter'
                                                        }
                                                        onClick={() => openRejet(candidature)}
                                                        disabled={isActionDisabled(candidature)}
                                                    >
                                                        <Ban size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Détails Candidat */}
            <Modal
                open={showDetailsModal}
                title={`Détails — ${selectedCandidature?.candidatTheque.nom || ''} ${
                    selectedCandidature?.candidatTheque.prenom || ''
                }`}
                onClose={() => setShowDetailsModal(false)}
                footer={
                    <button
                        className="apeBtn apeBtn--primary"
                        type="button"
                        onClick={() => setShowDetailsModal(false)}
                    >
                        Fermer
                    </button>
                }
            >
                {selectedCandidature && (
                    <div className="apeViewContent">
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Nom complet:</div>
                            <div className="apeViewValue">
                                {selectedCandidature.candidatTheque.nom}{' '}
                                {selectedCandidature.candidatTheque.prenom}
                            </div>
                        </div>
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Email:</div>
                            <div className="apeViewValue">{selectedCandidature.candidatTheque.email}</div>
                        </div>
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Téléphone:</div>
                            <div className="apeViewValue">{selectedCandidature.candidatTheque.phone}</div>
                        </div>
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Poste:</div>
                            <div className="apeViewValue">
                                {selectedCandidature.demandeRecrutement.demandeur.poste.nom}
                            </div>
                        </div>
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Manager:</div>
                            <div className="apeViewValue">
                                {selectedCandidature.demandeRecrutement.demandeur.nom}{' '}
                                {selectedCandidature.demandeRecrutement.demandeur.prenom}
                            </div>
                        </div>
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Département:</div>
                            <div className="apeViewValue">{selectedCandidature.departement}</div>
                        </div>
                        <div className="apeViewRow">
                            <div className="apeViewLabel">Statut:</div>
                            <div className="apeViewValue">
                                <button
                                    className={`apePill ${getStatusClass(selectedCandidature.statutDeCandidature)}`}
                                    type="button"
                                    disabled
                                >
                                    {selectedCandidature.statutDeCandidature}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </Modal>

            {/* Modal Motif (Rejet/Annulation) */}
            <Modal
                open={showMotifModal}
                title="Motif"
                onClose={() => setShowMotifModal(false)}
                footer={
                    <button
                        className="apeBtn apeBtn--primary"
                        type="button"
                        onClick={() => setShowMotifModal(false)}
                    >
                        Fermer
                    </button>
                }
            >
                {selectedCandidature && (
                    <div className="apeViewContent">
                        <div className="apeViewRow">
                            <div className="apeViewLabel">
                                {selectedCandidature.statutDeCandidature === 'Rejetée'
                                    ? 'Motif de rejet:'
                                    : 'Motif d\'annulation:'}
                            </div>
                            <div className="apeViewValue">
                                {selectedCandidature.motifRejet || selectedCandidature.motifAnnulation || '—'}
                            </div>
                        </div>
                    </div>
                )}
            </Modal>

            {/* Modal Confirmation Recrutement */}
            <Modal
                open={showConfirmationModal}
                title="Lettre de confirmation de recrutement"
                onClose={() => setShowConfirmationModal(false)}
                footer={
                    <button
                        className="apeBtn apeBtn--primary"
                        type="button"
                        onClick={() => setShowConfirmationModal(false)}
                    >
                        Fermer
                    </button>
                }
            >
                <div className="apeViewContent">
                    <p>Aperçu de la lettre de confirmation de recrutement pour :</p>
                    <div className="apeViewRow">
                        <div className="apeViewLabel">Candidat:</div>
                        <div className="apeViewValue">
                            {selectedCandidature?.candidatTheque.nom}{' '}
                            {selectedCandidature?.candidatTheque.prenom}
                        </div>
                    </div>
                    <div className="apeViewRow">
                        <div className="apeViewLabel">Poste:</div>
                        <div className="apeViewValue">
                            {selectedCandidature?.demandeRecrutement.demandeur.poste.nom}
                        </div>
                    </div>
                    <p className="apeMuted" style={{ marginTop: '16px', fontStyle: 'italic' }}>
                        Le document PDF sera généré et envoyé au candidat.
                    </p>
                </div>
            </Modal>

            {/* Modal Procédure Intégration */}
            <Modal
                open={showProcedureModal}
                title="Procédure d'intégration"
                onClose={() => setShowProcedureModal(false)}
                footer={
                    <button
                        className="apeBtn apeBtn--primary"
                        type="button"
                        onClick={() => setShowProcedureModal(false)}
                    >
                        Fermer
                    </button>
                }
            >
                <div className="apeViewContent">
                    <p>Procédure d'intégration pour :</p>
                    <div className="apeViewRow">
                        <div className="apeViewLabel">Candidat:</div>
                        <div className="apeViewValue">
                            {selectedCandidature?.candidatTheque.nom}{' '}
                            {selectedCandidature?.candidatTheque.prenom}
                        </div>
                    </div>
                    <div className="apeChecklist">
                        <h4>Étapes d'intégration :</h4>
                        <ul>
                            <li>✓ Préparation du poste de travail</li>
                            <li>✓ Création des accès informatiques</li>
                            <li>✓ Attribution du matériel</li>
                            <li>✓ Planification de la formation</li>
                            <li>✓ Rencontre avec l'équipe</li>
                        </ul>
                    </div>
                </div>
            </Modal>

            {/* Modal Rejet */}
            <Modal
                open={showRejetModal}
                title="Rejeter la candidature"
                onClose={() => setShowRejetModal(false)}
                footer={
                    <>
                        <button
                            className="apeBtn apeBtn--ghost"
                            type="button"
                            onClick={() => setShowRejetModal(false)}
                        >
                            Annuler
                        </button>
                        <button
                            className="apeBtn apeBtn--danger"
                            type="button"
                            onClick={rejeterCandidature}
                        >
                            Rejeter
                        </button>
                    </>
                }
            >
                <div className="apeForm">
                    <p>
                        Voulez-vous vraiment rejeter la candidature de{' '}
                        <strong>
                            {selectedCandidature?.candidatTheque.nom}{' '}
                            {selectedCandidature?.candidatTheque.prenom}
                        </strong>{' '}
                        ?
                    </p>
                    <div className="apeField">
                        <label>Motif de rejet *</label>
                        <textarea
                            rows={4}
                            value={motif}
                            onChange={(e) => setMotif(e.target.value)}
                            placeholder="Précisez le motif du rejet..."
                        />
                    </div>
                </div>
            </Modal>

            {/* Modal Annuler */}
            <Modal
                open={showAnnulerModal}
                title="Annuler la candidature"
                onClose={() => setShowAnnulerModal(false)}
                footer={
                    <>
                        <button
                            className="apeBtn apeBtn--ghost"
                            type="button"
                            onClick={() => setShowAnnulerModal(false)}
                        >
                            Annuler
                        </button>
                        <button
                            className="apeBtn apeBtn--danger"
                            type="button"
                            onClick={annulerCandidature}
                        >
                            Confirmer l'annulation
                        </button>
                    </>
                }
            >
                <div className="apeForm">
                    <p>
                        Voulez-vous vraiment annuler la candidature de{' '}
                        <strong>
                            {selectedCandidature?.candidatTheque.nom}{' '}
                            {selectedCandidature?.candidatTheque.prenom}
                        </strong>{' '}
                        ?
                    </p>
                    <div className="apeField">
                        <label>Motif d'annulation *</label>
                        <textarea
                            rows={4}
                            value={motif}
                            onChange={(e) => setMotif(e.target.value)}
                            placeholder="Précisez le motif de l'annulation..."
                        />
                    </div>
                </div>
            </Modal>
        </div>
    );
}